/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { branchSchema } from "./branchSchema.ts";

export const orgOrgUnitBranchListPathOrgUnitIdSchema = z.uuid();

export const orgOrgUnitBranchListStatus200Schema = z.array(branchSchema);

export const orgOrgUnitBranchListResponseSchema = orgOrgUnitBranchListStatus200Schema;
